module.exports = __webpack_public_path__ + "img/soccerboard77.f20ebde9.jpg";